import { QRCodeSVG } from "qrcode.react";
import { getAppStoreUrl, APP_STORE_URL, PLAY_STORE_URL, getPlatform } from "@/constants/site";

// Official Apple "Download on the App Store" badge (artwork in /public).
export const AppStoreBadge = ({ testId = "download-appstore", className = "" }) => (
  <a
    href={getAppStoreUrl()}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    aria-label="Download AuraLive on the App Store"
    className={`inline-block transition-transform hover:-translate-y-0.5 ${className}`}
  >
    <img src="/appstore-badge.svg" alt="Download on the App Store" className="h-[52px] w-auto" />
  </a>
);

// Official "Get it on Google Play" badge (artwork in /public).
export const GooglePlayBadge = ({ testId = "download-googleplay", className = "" }) => (
  <a
    href={PLAY_STORE_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    aria-label="Get AuraLive on Google Play"
    className={`inline-block transition-transform hover:-translate-y-0.5 ${className}`}
  >
    <img src="/googleplay-badge.svg" alt="Get it on Google Play" className="h-[52px] w-auto" />
  </a>
);

export const AppStoreQR = ({ testId = "download-qr", size = 92 }) => (
  <div data-testid={testId} className="rounded-xl bg-white p-2">
    <QRCodeSVG value={APP_STORE_URL} size={size} level="M" fgColor="#09090B" bgColor="#FFFFFF" />
  </div>
);

export const PlayStoreQR = ({ testId = "download-play-qr", size = 92 }) => (
  <div data-testid={testId} className="rounded-xl bg-white p-2">
    <QRCodeSVG value={PLAY_STORE_URL} size={size} level="M" fgColor="#09090B" bgColor="#FFFFFF" />
  </div>
);

// Renders both store badges, putting the visitor's detected platform first.
export const SmartStoreBadges = ({ idPrefix = "download", className = "" }) => {
  const platform = getPlatform();
  const apple = <AppStoreBadge key="apple" testId={`${idPrefix}-appstore`} />;
  const google = <GooglePlayBadge key="google" testId={`${idPrefix}-googleplay`} />;
  const ordered = platform === "android" ? [google, apple] : [apple, google];
  return (
    <div
      data-testid={`${idPrefix}-store-badges`}
      data-platform={platform}
      className={`flex flex-col items-center gap-4 sm:flex-row ${className}`}
    >
      {ordered}
    </div>
  );
};

// Two scannable QR codes (App Store + Google Play) with labels.
export const StoreQRCodes = ({ testIdPrefix = "download", size = 92, className = "" }) => (
  <div className={`flex items-center gap-5 ${className}`}>
    <div className="flex flex-col items-center gap-1.5">
      <AppStoreQR testId={`${testIdPrefix}-qr`} size={size} />
      <span className="text-[11px] font-semibold text-aura-text2">App Store</span>
    </div>
    <div className="flex flex-col items-center gap-1.5">
      <PlayStoreQR testId={`${testIdPrefix}-play-qr`} size={size} />
      <span className="text-[11px] font-semibold text-aura-text2">Google Play</span>
    </div>
  </div>
);
